import React, {useState, useEffect} from 'react';
import './fleetByStatus.scss';
import Pagination from '../pagination/pagination';

export default function FleetByStatus(params) {
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [Vehicles, setVehicles] = useState([]);
    const itemsPerPage = 10;

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);
    const handlePreviousPage = () => setCurrentPage(currentPage - 1);
    const handleNextPage = () => setCurrentPage(currentPage + 1);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedList = Vehicles.slice(startIndex, endIndex);

    const tone = params['title'].toLowerCase().replace(/\s+/g, '-');

    // Open issues per vehicle name (deduplicated), when this card is given issues
    const issuesByVehicle = {};
    (params['issues'] || []).forEach((issue) => {
        const vehicleName = issue.asset && issue.asset.name;
        if (!vehicleName) return;
        if (!issuesByVehicle[vehicleName]) issuesByVehicle[vehicleName] = [];
        if (!issuesByVehicle[vehicleName].some((existing) => existing.id === issue.id)) {
            issuesByVehicle[vehicleName].push(issue);
        }
    });

    function filterByVehicleStatus(vehicles, statusNames) {
        return vehicles.filter(function(vehicle) {
          return statusNames.includes(vehicle.vehicle_status_name);
        });
      }

    useEffect(() => {
        async function handleData() {
            const filteredData = filterByVehicleStatus(params['items'], params['statusNames']);
            // Vehicles with work orders first, then those without
            const groupedData = [...filteredData].sort((a, b) => (b.orders.length > 0) - (a.orders.length > 0));
            await setVehicles(groupedData);
            await setCurrentPage(1);
        };
        handleData()
        }
        , [params]);

    function renderVehicleRow(item) {
        const vehicleIssues = issuesByVehicle[item.name] || [];
        return (
            <li className='vehicle-row' key={item.id}>
                <a className='vehicle-name' target='_blank' rel='noreferrer' href={`https://secure.fleetio.com/${process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN}/vehicles/${item.id}`}>{item.name}</a>
                {item.orders.length !== 0 ? (
                    <span className='wo-group'>
                        <span className='wo-label'>WOs</span>
                        <span className='bracket'>[</span>
                        {item.orders.map((order, index) => (
                            <span className='wo' key={order.order_number}>
                                <a target='_blank' rel='noreferrer' href={order.url}>{order.order_number}</a>
                                <span className='wo-items'> ({order.items && order.items.length > 0 ? order.items.join(', ') : 'None'})</span>
                                {index < item.orders.length - 1 && <span className='wo-sep'>, </span>}
                            </span>
                        ))}
                        <span className='bracket'>]</span>
                    </span>
                ) : (
                    <span className='no-wo'>No WOs</span>
                )}
                {vehicleIssues.length > 0 && (
                    <span className='row-issues'>
                        {vehicleIssues.map((issue) => (
                            <a key={issue.id} className='issue-chip' target='_blank' rel='noreferrer' href={`https://secure.fleetio.com/${process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN}/issues/${issue.number}`} title={`Issue ${issue.number}`}>
                                {issue.summary || issue.name || `Issue ${issue.number}`}
                            </a>
                        ))}
                    </span>
                )}
            </li>
        );
    }

    return (
        <div className='box'>
            <div className='container'>
                <div className='card-header'>
                    <h2>{params['title']}</h2>
                    <span className={`count-pill tone-${tone}`}>{Vehicles.length}</span>
                </div>
                <ul className='vehicle-list'>
                    {Vehicles.slice(0, 5).map((item) => renderVehicleRow(item))}
                </ul>
                {Vehicles.length > 5 && (
                    <button className='show-modal-button' onClick={handleShowModal}>
                        Show all {Vehicles.length}
                    </button>
                )}
                {showModal && (
                    <div className='modal-overlay'>
                        <div className='modal'>
                            <div className='modal-header'>
                                <div className='card-header'>
                                    <h2>{params['title']}</h2>
                                    <span className={`count-pill tone-${tone}`}>{Vehicles.length}</span>
                                </div>
                                <button className='close-button' onClick={handleCloseModal}>
                                    &times;
                                </button>
                            </div>
                            <ul className='modal-body vehicle-list'>
                                {paginatedList.map((item) => renderVehicleRow(item))}
                            </ul>
                            <div className='modal-footer'>
                                <div className='footer-slot'>
                                    {currentPage > 1 && (
                                        <button className='previous-button' onClick={handlePreviousPage}>
                                            Previous
                                        </button>
                                    )}
                                </div>
                                {(currentPage > 1 || endIndex < Vehicles.length) && (
                                    <Pagination totalPages={Math.ceil(Vehicles.length / 10)} currentPage={currentPage}/>
                                )}
                                <div className='footer-slot footer-slot--right'>
                                    {endIndex < Vehicles.length && (
                                        <button className='next-button' onClick={handleNextPage}>
                                            Next
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
